import { render } from "./select_gift.vue?vue&type=template&id=f3446130"
import script from "./select_gift.vue?vue&type=script&lang=js"
export * from "./select_gift.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__